const plorbinEffects = [
    'stretch-glow',
    'rainbow-bounce',
    'marching-stripes',
    'glitch',
    'rainbow-shadow',
    'gif-smoke',
    'gif-confetti',
    'gif-rainbow-square',
    'gif-maze',
    'gif-yaoi'
]

export default plorbinEffects 